import { render, staticRenderFns } from "./PopupLayout.vue?vue&type=template&id=f816c5cc&"
import script from "./PopupLayout.vue?vue&type=script&lang=js&"
export * from "./PopupLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports